<template>
  <div class="dark:bg-(--p-neutral95) bg-(--p-neutral5) border-md rounded-(--p-border-radius-sm) overflow-hidden">
    <div class="h-[160px] bg-(--p-surface-200) dark:bg-(--p-surface-700)"></div>
    <div
      v-for="n in limitArray"
      :key="n"
      :class="[
        'p-4 flex gap-3 h-[72px] items-center justify-between',
        n < limitArray.length && 'border-b border-(--p-content-border-color)',
      ]"
    >
      <div>
        <div class="w-[100px] h-4 bg-(--p-surface-200) dark:bg-(--p-surface-700) rounded-sm mb-1"></div>
        <div class="w-[50px] h-3 bg-(--p-surface-200) dark:bg-(--p-surface-700) rounded-sm"></div>
      </div>
      <div class="flex flex-col gap-[2px]">
        <div class="w-[104px] h-[24px] bg-(--p-surface-200) dark:bg-(--p-surface-700) rounded-t-[4px]"></div>
        <div class="w-[104px] h-[24px] bg-(--p-surface-200) dark:bg-(--p-surface-700) rounded-b-[4px]"></div>
      </div>
    </div>
    <div class="p-4">
      <div class="w-[150px] h-4 bg-(--p-surface-200) dark:bg-(--p-surface-700) rounded-sm"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export interface MarketCardProps {
  size: 'large' | 'small';
  limit?: number;
}

const props = withDefaults(defineProps<MarketCardProps>(), {
  limit: 2,
});

// Create a computed array for v-for based on limit prop
const limitArray = computed(() => Array.from({ length: props.limit }, (_, i) => i + 1));
</script>
